module.exports = __webpack_public_path__ + "static/img/background.f5982fa4.svg";